import { menuGiftStore, chilPath } from 'app/config/config';
import { Router } from '@angular/router';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-out-of-stock-popup',
  templateUrl: './out-of-stock-popup.component.html',
  styleUrls: ['./out-of-stock-popup.component.scss'],
})
export class OutOfStockPopupComponent implements OnInit {

  @Input()
  public cUrl: string;
  @Output()
  public event: EventEmitter<string> = new EventEmitter<string>();
  constructor(private router: Router) { }

  ngOnInit() {}

  close(){
    this.event.emit("Close");
  }

  navigateGiftStore(){
    this.router.navigate([`${menuGiftStore.path}/${chilPath.giftList}`], { state: { backUrl: `${this.cUrl}`} });
  }

}
